var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { Table } from 'components';
var TaxesTable = /** @class */ (function (_super) {
    __extends(TaxesTable, _super);
    function TaxesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/taxes/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push("/taxes/create");
        };
        return _this;
    }
    TaxesTable.prototype.componentDidMount = function () {
        this.props.store.taxes.read();
    };
    TaxesTable.prototype.render = function () {
        var taxes = this.props.store.taxes;
        var headers = this.props.store.UI.isDesktop
            ? ['name', 'type', 'value', 'category']
            : ['name', 'type', 'value', 'category'];
        return (React.createElement(Table, { items: taxes.taxes, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (tax) { return String(tax.id); }, loading: !taxes.loaded }));
    };
    TaxesTable = __decorate([
        inject('store'),
        observer
    ], TaxesTable);
    return TaxesTable;
}(Component));
export default TaxesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/container/TaxesTable.tsx
// module id = 1262
// module chunks = 0